import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Router, RouterLink } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { LanguageApp } from '../../../config/datatable-config';
import { Helpers } from '../../../helpers/helpers';
import { Status } from '../../../enum/status';
import { RenaultManagerDistributorService } from '../../../services/renault-manager-distributor.service';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { DistributorMenuComponent } from './shared/menu/distributor-menu.component';
import { saveAs } from 'file-saver';
import { environment } from '../../../../environments/environment';
import { FileLoadComponent } from './fileload/fileload.component';

@Component({
  standalone: true,
  templateUrl: './distributor.component.html',
  styleUrls: ['./distributor.component.scss'],
  imports: [
    DataTablesModule,
    RouterLink,
    NgxDropzoneModule,
    DistributorMenuComponent,
    FileLoadComponent
  ]
})

export class DistributorComponent implements AfterViewInit, OnDestroy, OnInit {

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  @ViewChild(FileLoadComponent, { static: false })
  fileLoadComponent: FileLoadComponent;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  listenerFn!: () => void;
  blobPublic = environment.blobPublic;
  file: File[] = [];

  constructor(private helper: Helpers,
    private router: Router,
    private service: RenaultManagerDistributorService,
    private renderer: Renderer2,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.setDatatable();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
    this.listenerFn = this.renderer.listen('document', 'click', (event) => {
      if (event.target.hasAttribute("change-status-distributor-id")) {
        const id = event.target.getAttribute("change-status-distributor-id");
        const status = event.target.checked ? Status.Activo : Status.Inactivo;
        this.changeStatus(id, status);
      } else if (event.target.hasAttribute("delete-distributor-id")) {
        this.delete(event.target.getAttribute("delete-distributor-id"));
      } else if (event.target.hasAttribute("edit-distributor-id")) {
        this.router.navigate(["/admin/distributor/edit/" + event.target.getAttribute("edit-distributor-id")]);
      }
    });
    this.helper.setDataTableSearchDelay();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    if (this.listenerFn) {
      this.listenerFn();
    }
  }

  setDatatable() {
    const that = this;
    this.dtOptions = {
      responsive: true,
      paging: true,
      pageLength: 10,
      ordering: false,
      lengthChange: true,
      searching: true,
      info: true,
      serverSide: true,
      processing: true,
      language: LanguageApp.spanish_datatables,
      dom: LanguageApp.custom_dom_datatables,
      ajax: (dataTablesParameters: any, callback) => {
        that.service.getDataTable(dataTablesParameters).subscribe(resp => {
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: resp.data
          });
        }, (err) => {
          Swal.fire({
            icon: 'error',
            buttonsStyling: false,
            customClass: {
              cancelButton: 'btn-outline-black',
              confirmButton: 'btn-red'
            },
            title: 'Error al recuperar los datos',
            text: 'Ocurrió un error'
          });

        });
      },
      columns: [
        { data: "SocialName", className: "text-start" },
        { data: "TaxNumber", className: "text-center" },
        { data: "AccountNumber", className: "text-center" },
        { data: "PvGroup", className: "text-center" },
        { data: "VnPlate", className: "text-center" },
        { data: "SectorRenault", className: "text-center" },
        { data: "SectorDacia", className: "text-center" },
        { data: "InstallationCount", className: "text-center" },
        { data: "Status" },
        { data: "IdDistributor" },
      ],
      columnDefs: [

        {
          targets: [8],
          data: "Status",
          className: "align-middle text-center",
          render: function (data, type, full) {
            var retorno = "";
            retorno = '<div class="form-check form-switch">';
            if (data) {
              retorno += '<input type="checkbox" class="form-check-input" change-status-distributor-id ="' + full.IdDistributor + '" id="toggle' + full.IdDistributor + '" checked>';
            }
            else {
              retorno += '<input type="checkbox" class="form-check-input" change-status-distributor-id ="' + full.IdDistributor + '" id="toggle' + full.IdDistributor + '">';
            }
            retorno += '</div>';
            return retorno;
          }
        },
        {
          targets: [9],
          data: "IdDistributor",
          className: "align-middle text-center text-nowrap",
          render: function (data, type, full) {
            var retorno = "";
            retorno += '<div class="cont__btn-option"><button edit-distributor-id="' + data + '" class="btn-option-edit" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Editar"></button>';
            retorno += '<button delete-distributor-id="' + data + '"class="btn-option-delete" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Eliminar"></button></div>';
            return retorno;
          }
        }
      ]
    };
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance) => {
      dtInstance.draw();
    });
  }

  changeStatus(id: string, status: number) {
    this.service.changeStatus(id, status).subscribe(() => { }, (err) => {
      Swal.fire({
        icon: 'error',
        buttonsStyling: false,
        customClass: {
          cancelButton: 'btn-outline-black',
          confirmButton: 'btn-red'
        },
        title: 'Error al actualizar los datos',
        text: 'Ocurrió un error'
      });
    });
  }

  delete(id: string) {
    Swal.fire({
      title: '¿Quiere eliminar este elemento?',
      text: "El elemento desaparecerá del administrador",
      icon: 'warning',
      buttonsStyling: false,
      customClass: {
        cancelButton: 'btn-outline-black',
        confirmButton: 'btn-red'
      },
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: 'Eliminar <i class="fa-solid fa-trash-can"></i>',
      cancelButtonText: 'Cancelar <i class="fa-solid fa-xmark"></i>',
      reverseButtons: true,
      focusCancel: true
    }).then((result) => {
      if (result.value) {
        this.service.changeStatus(id, Status.Baja).subscribe(() => {
          this.toastr.success("El elemento se eliminó correctamente.");
          this.rerender();
        }, (err) => {
          Swal.fire({
            icon: 'error',
            buttonsStyling: false,
            customClass: {
              cancelButton: 'btn-outline-black',
              confirmButton: 'btn-red'
            },
            title: 'Error al eliminar el elemento',
            text: 'Ocurrió un error'
          });
        });
      }
    })
  }

  downloadExcel() {

    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Espere por favor...'
    });
    Swal.showLoading();

    this.service.downloadDistributorExcel().subscribe(blob => {
      Swal.close();
      saveAs(blob, "Renault_Distributors.xlsx");
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al acceder a la BD',
        text: 'Ocurrió un error',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-outline-secondary'
        },
        confirmButtonText: 'Cerrar'
      });
    });
  }

  onFileSelect(event) {
    if (this.file.length > 0) {
      this.file.splice(0, 1);
    }
    this.file.push(...event.addedFiles);
  }

  onFileRemove(event) {
    this.file.splice(this.file.indexOf(event), 1);
  }

  UpdateDistributorExcel() {
    if (this.file.length > 0) {

      Swal.fire({
        allowOutsideClick: false,
        icon: 'info',
        title: 'Cargando Datos',
        text: 'Espere por favor...'
      });
      Swal.showLoading();

      this.service.loadDistributorsExcel(this.file[0]).subscribe(resp => {
        this.file = [];
        Swal.close();
        this.toastr.success("Las referencias se han cargado correctamente");
        if (resp?.length) {
          this.helper.showFileLoadMessages(resp);
        }
        this.fileLoadComponent?.rerender();
        this.rerender();
        this.cdr.detectChanges();
      }, error => {
        Swal.fire({
          icon: 'error',
          title: 'Error al subir el fichero',
          text: error.error.length < 100 ? error.error : 'Ha ocurrido un error',
          buttonsStyling: false,
          customClass: {
            confirmButton: 'btn btn-outline-secondary'
          },
          confirmButtonText: 'Cerrar'
        });
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error al subir el fichero',
        text: 'Debes adjuntar un fichero',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-outline-secondary'
        },
        confirmButtonText: 'Cerrar'
      });
    }
  }

}

